import { useExperimentalFeature } from "@istari-frontend/experimental-features";
import type { Notification } from "@istari-frontend/notifications/model";
import { useCallback } from "react";

import { getNotificationUrl } from "~/notifications/feature/get-notification-url";

export function useNotificationUrl() {
  const { enabled: systemRedesign } = useExperimentalFeature("system-redesign");
  const { enabled: resourceRedesign } = useExperimentalFeature("resource-redesign");

  return useCallback(
    (notification: Notification) => getNotificationUrl(notification, { systemRedesign, resourceRedesign }),
    [systemRedesign, resourceRedesign],
  );
}
